var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-aside',{staticClass:"aside-class",attrs:{"width":_vm.width},on:{"update:width":function($event){_vm.width=$event}}},[_c('Aside',{attrs:{"width":_vm.width},on:{"update:width":function($event){_vm.width=$event}}})],1),_c('el-container',[_c('el-header',[_c('Header')],1),_c('el-main',[_c('Main')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }